import type { components } from "~/types/entity/emerIntwcApiWeb.schema";

export type Cookie2Token = components["schemas"]["V2IssueTokenResponseBody"]
// export type Cookie2Token = {
//   access_token: string
//   token_type: string
//   id_token: string
//   expires_in: number
// }
export type Role = "Bronze" | "Gold" | "Platinum" | "Silver" | "Participant" | "Attendee" | "Staff" // | ""
/**
 * ここに含まれない Role を State に入れて管理しない
 */
export const validRoleList: Array<Role> = ["Platinum", /* "Gold", "Silver", */ "Bronze"];
/**
 * ここに含まれない Role を表示しない
 */
export const displayRoleList: Array<Role> = ["Platinum"];
// https://dev.azure.com/cosat/Circlems/_git/ComikeWebCatalog?path=%2Fclient-app%2Fsrc%2Futils%2FurlHelper.ts
// において画面ごとの権限表として記述している
// export const authorizatedRoles: Array<Role> = ["Platinum", "Gold"];

// API の側は roles を 文字列として定義している。Webアプリ側で Role として扱いたいため型定義している
// export type UserInfo = components["schemas"]["V2UserInfoItem"]
export type UserInfo = {
  sub: string
  nickname: string
  email: string
  email_verified: boolean
  updated_at: number
  circlems_r18: number
  birthdate: string | undefined
  roles: Array<Role>
}

export type AuthToken = {
  accessToken: string
  expiresAt: number | undefined
  iat: number | undefined
  loginAttemptAt: number
}

export type UserState = {
  userInfo: UserInfo // | undefined // 未ログイン時も undefined は許可せず 未ログイン状態の UserInfo を格納する
  token: AuthToken | undefined
}

export type AccessTokenWithLoginOption = {
  getAccessTokenWithLogin: () => Promise<string | undefined>
  // getValidAuthToken: () => AuthToken | undefined
  // setUserState: (token: AuthToken | undefined, userInfoItem: components["schemas"]["V2UserInfoItem"] | undefined) => void
}
